import { render, staticRenderFns } from "./taskProgress.vue?vue&type=template&id=4345410c&"
import script from "./taskProgress.vue?vue&type=script&lang=js&"
export * from "./taskProgress.vue?vue&type=script&lang=js&"
import style0 from "./taskProgress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports